import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { OmitStylesComponentProps } from '../../types';
import { cva, VariantProps } from 'class-variance-authority';

export const checkboxVariants = cva(
    'rocco-checkbox peer shrink-0 border ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 overflow-hidden',
    {
        variants: {
            color: {
                default:
                    'border-gray-900 data-[state=checked]:bg-gray-900 data-[state=checked]:text-primary',
            },
            size: {
                default: 'h-4 w-4',
                small: 'h-2.5 w-2.5',
            },
            shape: {
                default: 'rounded-sm',
                round: 'rounded-full',
            },
            groupHover: {
                light: 'group-hover:border-white group-hover:[&[data-state=checked]]:bg-white group-hover:[&[data-state=checked]]:text-black',
                default: '',
            },
        },
        defaultVariants: {
            color: 'default',
            size: 'default',
            shape: 'default',
            groupHover: 'default',
        },
    },
);

export const checkboxIconVariants = cva('', {
    variants: {
        size: {
            default: 'h-4 w-4',
            small: 'h-2.5 w-2.5',
        },
    },
    defaultVariants: {
        size: 'default',
    },
});

export const Checkbox = React.forwardRef<
    React.ElementRef<typeof CheckboxPrimitive.Root>,
    OmitStylesComponentProps<typeof CheckboxPrimitive.Root> &
        VariantProps<typeof checkboxVariants>
>(({ color, size, shape, groupHover, ...props }, ref) => (
    <CheckboxPrimitive.Root
        ref={ref}
        className={checkboxVariants({ color, size, shape, groupHover })}
        {...props}
    >
        <CheckboxPrimitive.Indicator
            className={'flex items-center justify-center text-current'}
        >
            {shape !== 'round' && (
                <Check className={checkboxIconVariants({ size })} />
            )}
        </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
));

Checkbox.displayName = CheckboxPrimitive.Root.displayName;
